module.exports = __webpack_public_path__ + "img/MOVE.038613c5.svg";